import React, { useEffect, useState } from "react";
import "./styles.css";
import { Modal } from "react-bootstrap";
import Calendar from "react-calendar";
import swal from "sweetalert";
import SentMessagesList from "./SentMessagesList";
import Group from "./Group";
import { Switch, Route, NavLink } from "react-router-dom";
import Select, { components } from "react-select";
import { v4 as uuid } from "uuid";
import Axios from "axios";
import Loader from "../UI Component/Loader/Loader";
import moment from "moment";
import afterLoginApiAxios from "./../../Util/API Calls/afterLogin";
import { green } from "@material-ui/core/colors";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

const SendMessages = (props) => {
  const [messageSentCounter, setMessageSentCounter] = useState(0);
  const [patients, setPatients] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [searchedPatient, setSearchedPatient] = useState("");
  const [searchedGroup, setSearchedGroup] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [consultedDate, setConsultedDate] = useState(new Date());
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [customisedMessage, setCustomisedMessage] = useState("");
  const [approvedPatients, setApprovedPatients] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newNumber, setNewNumber] = useState(false);
  const [notFound, setNotFound] = useState("");
  const [patientsConsulted, setPatientsConsulted] = useState(true);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
  };

  const handleCloseModal = () => {
    setConsultedDate(new Date());
    setPatientsConsulted(true);
    setSearchedPatient("");
    setShowModal(false);
  };
  const handleShowModal = (event) => {
    if (event.target == event.currentTarget) {
      event.stopPropagation();
    }
    setShowModal(true);
  };
  const handleDate = (date) => {
    setLoading(true);
    let formattedDate = moment(date).format("YYYY-MM-DD");
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-care-group/",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        appointment_date: formattedDate,
        "authorizer-principal-id": {
          user_type: "1",
        },
      },
    }).then(function (response) {
      let patientsResp = [];
      let apiResp = response.data.all_patients;
      for (let i = 0; i < apiResp.length; i++) {
        let tempPatient = {};
        tempPatient["id"] = apiResp[i]["patient_id"];
        tempPatient["name"] = apiResp[i]["patient_name"];
        tempPatient["phone"] = apiResp[i]["patient_number"];
        tempPatient["selected"] = true;
        if (apiResp[i]["patient_name"].split(" ").length > 1) {
          tempPatient["initials"] =
            apiResp[i]["patient_name"].split(" ")[0].charAt(0) +
            apiResp[i]["patient_name"].split(" ")[1].charAt(0);
        } else {
          tempPatient["initials"] = apiResp[i]["patient_name"]
            .split(" ")[0]
            .charAt(0);
        }
        patientsResp.push(tempPatient);
      }
      if (patientsResp.length === 0) {
        setPatientsConsulted(false);
      } else {
        setPatientsConsulted(true);
      }
      setSelectedPatients(patientsResp);
      setConsultedDate(date);
      setLoading(false);
      setShowCalendar(!showCalendar);
    });
  };

  useEffect(() => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-care-group/",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        appointment_date: "",
        "authorizer-principal-id": {
          user_type: "1",
        },
      },
    }).then(function (response) {
      let patientsResp = [];
      let apiResp = response.data.all_patients;
      for (let i = 0; i < apiResp.length; i++) {
        let tempPatient = {};
        tempPatient["id"] = apiResp[i]["patient_id"];
        tempPatient["name"] = apiResp[i]["patient_name"];
        tempPatient["phone"] = apiResp[i]["patient_number"];
        tempPatient["selected"] = false;
        if (apiResp[i]["patient_name"].split(" ").length > 1) {
          tempPatient["initials"] =
            apiResp[i]["patient_name"].split(" ")[0].charAt(0) +
            apiResp[i]["patient_name"].split(" ")[1].charAt(0);
        } else {
          tempPatient["initials"] = apiResp[i]["patient_name"]
            .split(" ")[0]
            .charAt(0);
        }
        patientsResp.push(tempPatient);
      }
      setPatients(patientsResp);
    });
  }, [window.localStorage]);

  useEffect(() => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/list-groups",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        "authorizer-principal-id": {
          user_type: "1",
        },
      },
    }).then(function (response) {
      response = response.data.group_list;
      let groupResp = [];
      groupResp = response.map((group) => {
        let tempGroupObject = {};
        tempGroupObject["patients"] = group.patient_info
          .map((info) => {
            return info.full_name;
          })
          .join();
        tempGroupObject["id"] = group.group_id;
        tempGroupObject["name"] = group.group_name;
        tempGroupObject["initials"] = group.group_name.split(" ")[0].charAt(0);
        tempGroupObject["selected"] = false;
        tempGroupObject["status"] = group.status;
        tempGroupObject["patientinfo"] = group.patient_info.map((patient) => {
          return {
            id: patient.patient_id,
            initials: patient.full_name.split(" ")[0].charAt(0),
            name: patient.full_name,
            phone: patient.phone_no,
            selected: true,
          };
        });
        return tempGroupObject;
      });
      setGroups(groupResp);
    });
  }, [window.localStorage, window.localStorage.getItem("group_list")]);

  useEffect(() => {
    setFilteredPatients(
      patients.filter((patient) => {
        return (
          patient.name.toLowerCase().includes(searchedPatient.toLowerCase()) ||
          patient.phone.includes(searchedPatient)
        );
      })
    );
  }, [searchedPatient, patients]);

  useEffect(() => {
    setFilteredGroups(
      groups.filter((group) => {
        return (
          group.status == "1" &&
          group.name.toLowerCase().includes(searchedGroup.toLowerCase())
        );
      })
    );
  }, [searchedGroup, groups]);

  const sentMessagesData = [];

  const handleCheckAllPatients = (event) => {
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    setCheckedAll(event.target.checked);
    patientsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected.push(p);
        }
      } else {
        if (patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected = patientsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const handleCheckAllGroups = (event) => {
    let groupsAvailable = [...groups];
    let groupsSelected = [...selectedGroups];
    //setCheckedAll(event.target.checked);
    groupsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!groupsSelected.some((ps) => ps.id === p.id)) {
          groupsSelected.push(p);
        }
      } else {
        if (groupsSelected.some((ps) => ps.id === p.id)) {
          groupsSelected = groupsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setSelectedGroups(groupsSelected);
    setGroups(groupsAvailable);
  };

  const handleCheckPatientContact = (event) => {
    setLoading(true);
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === event.target.value) {
        patientsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (
            !patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected.push(patientsAvailable[i]);
          }
        } else {
          if (
            patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected = patientsSelected.filter(
              (ps) => ps.id !== patientsAvailable[i].id
            );
          }
        }
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (patientsSelected.length === patients.length && checkedAll === false) {
      setCheckedAll(true);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
    setLoading(false);
  };

  const handleCheckGroupContact = (event) => {
    setLoading(true);
    let groupsAvailable = [...groups];
    let groupsSelected = [...selectedGroups];
    for (var i = 0; i < groupsAvailable.length; i++) {
      if (groupsAvailable[i].id === event.target.value) {
        groupsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (!groupsSelected.some((ps) => ps.id === groupsAvailable[i].id)) {
            groupsSelected.push(groupsAvailable[i]);
          }
        } else {
          if (groupsSelected.some((ps) => ps.id === groupsAvailable[i].id)) {
            groupsSelected = groupsSelected.filter(
              (ps) => ps.id !== groupsAvailable[i].id
            );
          }
        }
      }
    }
    if (groupsSelected.length < groups.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (groupsSelected.length === groups.length && checkedAll === false) {
      setCheckedAll(true);
    }
    setSelectedGroups(groupsSelected);
    setGroups(groupsAvailable);
    setLoading(false);
  };

  const removeSelectedPatient = (index) => {
    let patientsSelected = [...selectedPatients];
    let patientsAvailable = [...patients];
    patientsSelected = patientsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === index) {
        patientsAvailable[i].selected = false;
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const removeSelectedGroup = (index) => {
    let groupsSelected = [...selectedGroups];
    let groupsAvailable = [...groups];
    groupsSelected = groupsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < groupsAvailable.length; i++) {
      if (groupsAvailable[i].id === index) {
        groupsAvailable[i].selected = false;
      }
    }
    if (groupsSelected.length < groups.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setSelectedGroups(groupsSelected);
    setGroups(groupsAvailable);
  };

  const removeApprovedPatient = (e, index) => {
    e.stopPropagation();
    let patientsApproved = [...approvedPatients];
    patientsApproved = patientsApproved.filter((pa) => pa.id !== index);
    if (patientsApproved.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setApprovedPatients(patientsApproved);
    removeSelectedPatient(index);
  };

  const templateSelected = (value) => {
    setSelectedTemplate(value.id);
    setSelectedTitle(value.title);
    let message = "";
    props.presetTemplates.forEach((pm) => {
      if (pm.id === value.id) {
        setCustomisedMessage(value.message_body);
        return;
      }
    });
  };

  const handleMessageCustomisation = (e) => {
    setCustomisedMessage(e.target.value);
    if (e.target.value.length > 160 || customisedMessage > 160) {
      setCustomisedMessage(e.target.value.substring(0, 160));
      swal({
        title: "Keep Message in Range",
        text: "Message cannot be greater than 160 words",
        type: "error",
        icon: "warning",
      }).then(() => {});
    } else {
      setCustomisedMessage(e.target.value.substring(0, 160));
    }
  };

  const patientsFound = () => {
    if (selectedGroups.length > 0) {
      let selectedGroupPatients = selectedGroups.map((group) => {
        return group.patientinfo;
      });
      selectedGroupPatients = [].concat.apply([], selectedGroupPatients);
      setApprovedPatients([...selectedGroupPatients]);
    } else {
      setApprovedPatients([...selectedPatients]);
    }

    handleCloseModal();
  };

  const handleNewContact = (e) => {
    if (!isNaN(e.target.value)) {
      if (e.target.value.length < 10) {
        setNotFound("Please Enter Valid Number or Select One");
        setNewNumber(true);
      } else if (e.target.value.length === 10) {
        let newSelectedArr = [
          ...selectedPatients,
          {
            id: uuid(),
            name: e.target.value,
            initials: "N",
            phone: "+91" + e.target.value.substr(-10),
            selected: true,
            isNew: true,
          },
        ];
        setSelectedPatients(newSelectedArr);
      } else {
        setNotFound("Please Enter Valid Number or Select One");
        setNewNumber(true);
      }
    } else {
      setNotFound("No Number found with this Name");
      setNewNumber(true);
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    if (approvedPatients.length > 0 && customisedMessage.length > 3) {
      let finalRequestData = [];
      for (let i = 0; i < approvedPatients.length; i++) {
        let tempMess = {
          patient_phone_no: approvedPatients[i]["phone"],
          patient_id: approvedPatients[i]["id"],
          // id: selectedTemplate
        };
        if (approvedPatients[i]["isNew"]) {
          tempMess["patient_new"] = true;
        } else {
          tempMess["patient_new"] = false;
        }
        finalRequestData.push(tempMess);
      }

      afterLoginApiAxios({
        method: "post",
        url: "/doctor/send-sms",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
        data: {
          "authorizer-principal-id": {
            user_type: "1",
          },
          doctor_id: doctor_id,
          preset_message: selectedTitle,
          message_body: customisedMessage,
          request: finalRequestData,
        },
      }).then(function (response) {
        if (response.data.errorMessage) {
          setLoading(false);
          swal({
            title: "Message Not Sent",
            text: "Some error occured",
            type: "error",
            icon: "warning",
          }).then(function () {});
        } else {
          setLoading(false);
          swal({
            title: "Message Sent!",
            text: "Message Sent Succesfully to Patients",
            icon: "success",
          }).then(function (t) {
            if (t) {
              setSelectedPatients([]);
              setSelectedTemplate("");
              setSelectedTitle("");
              setCustomisedMessage("");
              setApprovedPatients([]);
              setCheckedAll(false);
              setSelectedGroups([]);
              let patientsAvailable = [...patients];
              patientsAvailable.forEach((p) => {
                p.selected = false;
              });
              setPatients(patientsAvailable);
              let groupsAvailable = [...groups];
              groupsAvailable.forEach((p) => {
                p.selected = false;
              });
              setGroups(groupsAvailable);
            }
          });
        }
      });
    } else if (customisedMessage.length <= 3) {
      setLoading(false);
      swal({
        title: "Message Not Sent",
        text: "Message cannot be less than 3 words",
        type: "error",
        icon: "warning",
      }).then(function () {});
    } else {
      setLoading(false);
      swal({
        title: "Message Not Sent",
        text: "Please fill in to send the messages",
        type: "error",
        icon: "warning",
      }).then(function () {});
    }
  };

  return (
    <>
      <div className="col-12">
        <div className="message-compase">
          <div className="col-sm-12 col-lg-12">
            <h5>
              <strong>
                <b>MESSAGES</b>
              </strong>
            </h5>
          </div>
          <ul role="tablist" className="nav nav-tabs messages-tab">
            <li role="presentation" className="nav-item">
              <a
                role="tab"
                data-toggle="tab"
                className="nav-link active"
                href="#tab-1"
              >
                Compose Message
              </a>
            </li>
            <li role="presentation" className="nav-item">
              <a
                role="tab"
                data-toggle="tab"
                className="nav-link"
                href="#tab-3"
                onClick={() => props.initialApiCall()}
              >
                Sent Messages
              </a>
            </li>
            <li role="presentation" className="nav-item">
              <a
                role="tab"
                data-toggle="tab"
                className="nav-link"
                href="#tab-11"
              >
                Groups
              </a>
            </li>
          </ul>
          <div className="tab-content mt-5">
            {loading ? <Loader /> : null}
            <div className="tab-pane active" role="tabpanel" id="tab-1">
              <div
                className="form-group"
                onClick={handleShowModal}
                style={{
                  lineHeight: "25px",
                }}
              >
                <div
                  className="d-flex tag-container bg-white align-items-center"
                  style={{ minHeight: "2.5rem" }}
                >
                  {approvedPatients.length > 0 ? (
                    <>
                      {approvedPatients.map((sp, i) => {
                        if (i < 3)
                          return (
                            <PatientTag
                              key={sp.id}
                              {...sp}
                              removeApprovedPatient={removeApprovedPatient}
                            />
                          );
                      })}
                    </>
                  ) : (
                    <small
                      style={{ fontSize: "1rem", marginLeft: "6px" }}
                      className="text-muted"
                    >
                      Select contact(s) or group
                    </small>
                  )}
                  {approvedPatients.length > 3 ? (
                    <>
                      <PatientTagMore number={approvedPatients.length - 3} />
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="d-flex justify-content-center align-items-center plus-cont">
                    <i className="fa fa-plus plus-icon"></i>
                  </div>
                </div>
                <small className="text-muted mt-1">
                  Total Recipients: {approvedPatients.length}
                </small>
              </div>
              <div className="form-group">
                <Select
                  styles={customStyles}
                  options={props.presetTemplates}
                  onChange={templateSelected}
                  getOptionLabel={(option) => `${option.title}`}
                  getOptionValue={(option) => `${option.id}`}
                  placeholder={"Please select a preset message"}
                  components={{ DropdownIndicator }}
                  value={
                    selectedTemplate !== ""
                      ? {
                          id: selectedTemplate,
                          title: selectedTitle,
                        }
                      : null
                  }
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control input-scrollStyle"
                  rows="6"
                  placeholder="Message"
                  value={customisedMessage}
                  onChange={handleMessageCustomisation}
                />
                <small className="text-muted mt-1">
                  Number of characters:{customisedMessage.length}/160
                </small>
              </div>
              <div className="form-group">
                <button
                  className="btn btn-primary"
                  type="button"
                  style={{
                    background: "#17bae0",
                  }}
                  onClick={handleSubmit}
                >
                  Send Message
                </button>
              </div>
            </div>
            <div className="tab-pane" role="tabpanel" id="tab-11">
              <div>
                <Group messages={props.Group_list} />
              </div>
            </div>
            <div className="tab-pane" role="tabpanel" id="tab-3">
              <div>
                <SentMessagesList messages={props.sentMessages} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        scrollable="true"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>SEND TO</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contact-scroll container_scroll patient-container">
          <div>
            {loading ? <Loader /> : null}
            <ul
              role="tablist"
              className="nav nav-tabs messages-tab"
              style={{ fontSize: "12px" }}
            >
              <li role="presentation" className="nav-item">
                <a
                  role="tab"
                  data-toggle="tab"
                  className="nav-link active"
                  href="#tab-4"
                >
                  Contacts
                </a>
              </li>
              <li role="presentation" className="nav-item">
                <a
                  role="tab"
                  data-toggle="tab"
                  className="nav-link"
                  href="#tab-5"
                >
                  By Appointment Date
                </a>
              </li>
              <li role="presentation" className="nav-item">
                <a
                  role="tab"
                  data-toggle="tab"
                  className="nav-link"
                  href="#tab-12"
                >
                  Groups
                </a>
              </li>
            </ul>
            <div className="tab-content my-3">
              <div role="tabpanel" className="tab-pane active" id="tab-4">
                <div className="shadow search-box mx-3">
                  <input
                    type="text"
                    className="search-txt"
                    placeholder="Search by Name or Phone number"
                    onChange={(e) => setSearchedPatient(e.target.value)}
                    onKeyPress={(e) => {
                      if (newNumber) {
                        setNewNumber(false);
                      }
                      if (e.key === "Enter") {
                        let count = 0;
                        if (selectedPatients.length > 0) {
                          for (let i = 0; i < selectedPatients.length; i++) {
                            if (
                              selectedPatients[i].phone ===
                              "+91" + e.target.value
                            ) {
                              count = 1;
                              break;
                            }
                          }
                          if (count === 1) {
                            return;
                          } else {
                            handleNewContact(e);
                          }
                        } else {
                          handleNewContact(e);
                        }
                      }
                    }}
                  />
                  <span className="search-btn">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
                <small
                  className="text-danger ml-3 mt-2"
                  style={{ display: newNumber ? "block" : "none" }}
                >
                  {notFound}
                </small>
                {selectedPatients.length > 0 ? (
                  <div className="m-2 selected_list">
                    <hr />
                    <div className="selected-contacts mt-3">
                      {selectedPatients.map((sp) => (
                        <SelectedPatient
                          key={sp.id}
                          {...sp}
                          removeSelectedPatient={removeSelectedPatient}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="select-all my-2">
                  <input
                    type="checkbox"
                    id="select-all"
                    checked={checkedAll}
                    onChange={handleCheckAllPatients}
                  />
                  <label htmlFor="select-all" className="m-3">
                    Select All Contacts
                  </label>
                </div>
                <div class="contact-list">
                  {filteredPatients.map((patient) => (
                    <PatientContact
                      key={patient.id}
                      {...patient}
                      handleCheckPatientContact={handleCheckPatientContact}
                    />
                  ))}
                </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="tab-5">
                <div className="container my-2">
                  <div className="d-flex">
                    <div className="d-flex justify-content-center align-items-center calendar-information">
                      <i className="fa fa-info"></i>
                    </div>
                    <p>
                      <b>
                        All patients with an appointment on this day will
                        receive the message
                      </b>
                    </p>
                  </div>
                </div>
                <div
                  className="shadow calendar-box my-2"
                  onClick={() => setShowCalendar(!showCalendar)}
                >
                  <input
                    type="text"
                    className="calendar-input"
                    placeholder="Select a date"
                  />
                  <span className="calendar-btn">
                    <i className="fa fa-calendar"></i>
                  </span>
                </div>
                <div class="consultation-calendar">
                  <Calendar
                    className={showCalendar ? "" : "hide"}
                    onChange={handleDate}
                    value={consultedDate}
                    date={consultedDate}
                  />
                </div>

                {/* //asdjklhsjkfndklfgn */}
                {!patientsConsulted ? (
                  <small className="text-danger ml-3">
                    No Patients Consulted on this date
                  </small>
                ) : null}
                {selectedPatients.length > 0 ? (
                  <div className="m-2">
                    <hr />
                    <div className="selected-contacts mt-3">
                      {selectedPatients.map((sp) => (
                        <SelectedPatient
                          key={sp.id}
                          {...sp}
                          removeSelectedPatient={removeSelectedPatient}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div role="tabpanel" className="tab-pane" id="tab-12">
                <div className="shadow search-box mx-3">
                  <input
                    type="text"
                    className="search-txt"
                    placeholder="Search for a group"
                    onChange={(e) => setSearchedGroup(e.target.value)}
                    // onKeyPress={(e) => {
                    //   if (newNumber) {
                    //     setNewNumber(false);
                    //   }
                    //   if(e.key === 'Enter') {
                    //     let count = 0;
                    //     if(selectedPatients.length > 0) {
                    //       for(let i=0; i<selectedPatients.length; i++) {
                    //         if(selectedPatients[i].phone === ("+91" + e.target.value)) {
                    //           count = 1;
                    //           break;
                    //         }
                    //       }
                    //       if(count === 1) {
                    //         return;
                    //       }
                    //       else {
                    //         handleNewContact(e)
                    //       }
                    //     }
                    //     else {
                    //       handleNewContact(e)
                    //     }
                    //   }
                    // }}
                  />
                  <span className="search-btn">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
                {selectedGroups.length > 0 ? (
                  <div className="m-2">
                    <hr />
                    <div className="selected-contacts mt-3">
                      {selectedGroups.map((sp) => (
                        <SelectedGroup
                          key={sp.id}
                          {...sp}
                          removeSelectedGroup={removeSelectedGroup}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="select-all my-2">
                  {/* <input
                    type="checkbox"
                    id="select-all"
                    checked={checkedAll}
                    onChange={handleCheckAllGroups}
                  />
                  <label htmlFor="select-all" className="m-3">
                    Select All Groups
                  </label> */}
                </div>
                <div class="contact-list">
                  {filteredGroups.map((group) => (
                    <GroupContact
                      key={group.id}
                      {...group}
                      handleCheckGroupContact={handleCheckGroupContact}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <button
            type="button"
            className="btn border rounded modal-okay"
            onClick={patientsFound}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const PatientContact = ({
  id,
  name,
  initials,
  phone,
  selected,
  handleCheckPatientContact,
}) => {
  return (
    <div className="checkbox-container my-2">
      <input
        type="checkbox"
        id={id}
        checked={selected}
        value={id}
        key={id}
        onChange={handleCheckPatientContact}
      />
      <label htmlFor={id} className="ml-2" data-letters={initials}>
        <div className="single-contact">
          {name}
          <small className="text-muted">{phone}</small>
        </div>
      </label>
    </div>
  );
};

const GroupContact = ({
  id,
  name,
  selected,
  initials,
  patients,
  handleCheckGroupContact,
}) => {
  return (
    <div className="checkbox-container my-2">
      <input
        type="checkbox"
        id={id}
        checked={selected}
        value={id}
        key={id}
        onChange={handleCheckGroupContact}
      />
      <label htmlFor={id} className="ml-2" data-letters={initials}>
        <div className="single-contact">
          {name}
          <small className="text-muted">{patients}</small>
        </div>
      </label>
    </div>
  );
};

const SelectedPatient = ({ id, initials, name, removeSelectedPatient }) => {
  return (
    <div className="selected-contact">
      <span data-letters={initials}></span>
      <i
        className="fa fa-close selected-close-icon"
        onClick={() => removeSelectedPatient(id)}
      ></i>
      <div className="selected-names">{name.split(" ")[0]}</div>
    </div>
  );
};

const SelectedGroup = ({ id, initials, name, removeSelectedGroup }) => {
  return (
    <div className="selected-contact">
      <span data-letters={initials}></span>
      <i
        className="fa fa-close selected-close-icon"
        onClick={() => removeSelectedGroup(id)}
      ></i>
      <div className="selected-names">{name.split(" ")[0]}</div>
    </div>
  );
};

const PatientTag = ({ name, id, removeApprovedPatient }) => {
  return (
    <div className="shadow-sm tag">
      <span style={{ fontSize: "0.8rem" }}>{name}</span>
      <i
        className="fa fa-close approved-close-icon"
        onClick={(e) => removeApprovedPatient(e, id)}
      ></i>
    </div>
  );
};

const PatientTagMore = (props) => {
  return (
    <button
      className="btn border rounded ml-3"
      type="button"
      style={{
        backgroundColor: "#17bae0",
        color: "#fff",
      }}
    >
      {props.number} More
    </button>
  );
};

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {/*<FontAwesomeIcon icon={props.selectProps.menuIsOpen ? "caret-up" : "caret-down"}/>*/}
        {props.selectProps.menuIsOpen ? (
          <i className="fa fa-caret-up" style={{ color: "#17bae0" }}></i>
        ) : (
          <i className="fa fa-caret-down" style={{ color: "#17bae0" }}></i>
        )}
      </components.DropdownIndicator>
    )
  );
};

export default SendMessages;
